import LiveHelpOutlinedIcon from '@mui/icons-material/LiveHelpOutlined';
import {
  AccordionDetails,
  Button,
  FormControl,
  FormControlLabel,
  Grid,
  Radio,
  RadioGroup,
  Stack,
  TextField
} from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { usePermissionWrapper } from 'src/components/hooks/usePermissionWrapper';
import { useUser } from 'src/components/hooks/useUser';
import { sectionNames } from 'src/components/QueryMenus/checklistQueriesData';
import { QueryMenus } from 'src/components/QueryMenus/QueryMenus';
import { SectionQueryIndication } from 'src/components/QueryMenus/sectionQueryIndication';
import { useQueryMenus } from 'src/components/QueryMenus/useQueryMenus';
import { ViewQuery } from 'src/components/QueryMenus/ViewQuery/ViewQuery';
import { sendRequest } from 'src/hooks/useFetch';
import { setConfirmExitValue } from 'src/store/confirmExitValue';
import { useAppDispatch, useAppSelector } from 'src/store/hooks';
// import { setSnackbarMessage } from 'src/store/snackbarMessage';
import { clearMessage, setMessage } from 'src/store/Message';
import { ISIVReportRequirementsforEcrfcompletion } from 'src/types/SIVReport';
import { formatInput } from 'src/util/STR';
import { useFieldTranslation } from '../../fields/useFieldTranslation';
import {
  IRequirementsforEcrfcompletionMandatory,
  ISIVReportMandatory,
  ISIVReportModifiedKeys,
  ISIVReportModifiedKeysOfKeys,
  MandatoryData
} from './useSivReport';
import { setIsSaveButtonDisable } from 'src/store/sivReport';

const NOTES_MAXLENGTH = 2000;

export interface IRequirementsforEcrfcompletion {
  getSivReportData: (key: ISIVReportModifiedKeysOfKeys, add: boolean) => void;
  saveDisable: boolean;
  requirementsforEcrfCompletionData: ISIVReportRequirementsforEcrfcompletion;
  updateRequirementsforEcrfCompletion: (data: ISIVReportRequirementsforEcrfcompletion) => void;
  isUpdate: boolean;
  isChange: boolean;
  setIsChange: (step: ISIVReportModifiedKeys, key: ISIVReportModifiedKeysOfKeys, val: boolean) => void;
  updateSIVReportMandatoryData: (key: keyof ISIVReportMandatory, value: MandatoryData) => void;
  mandatory: IRequirementsforEcrfcompletionMandatory;
  sivReportSavedId: string;
  checkedInStartDate: any;
  isPublished: boolean;
  SignatureBreaking: () => void;
}

const RequirementsforEcrfcompletion: React.FunctionComponent<IRequirementsforEcrfcompletion> = ({
  getSivReportData,
  saveDisable,
  isUpdate,
  requirementsforEcrfCompletionData,
  updateRequirementsforEcrfCompletion,
  isChange,
  setIsChange,
  mandatory,
  updateSIVReportMandatoryData,
  sivReportSavedId,
  checkedInStartDate,
  isPublished,
  SignatureBreaking
}) => {
  const dispatch = useDispatch();
  const dispatchApp = useAppDispatch();
  const user = useUser();
  const { sivcDataUpdateSuccessMsg, sivcMendatoryInfoErrorMsg, reportReqForECRFCompletion } = useFieldTranslation();

  const studyId: any = useAppSelector(state => state.site.selectedStudy);
  const selectedCountry = useAppSelector(state => state.site.selectedCountry);
  const selectedSite = useAppSelector(state => state.site.selectedSite);
  const { checkPermission } = usePermissionWrapper();
  const isDisable = checkPermission('update_siv_report');
  const perDisableQuery = checkPermission('view_queries_siv_report');
  const selectedRowData: any = useAppSelector(state => state.sivReport.selectedRowData);
  const saveButtonDisable: any = useAppSelector(state => state.sivReport.disableSaveButtonProps);
  const [refreshKey, setRefreshKey] = useState(0);
  const [recentData, setRecentData] = useState({ data: {}, mandatoryValidation: {} });
  const errorText = 'Required';

  useEffect(() => {
    if (requirementsforEcrfCompletionData) {
      setRefreshKey(refreshKey + 1);
    }
  }, [Object.keys(requirementsforEcrfCompletionData)?.length]);

  const handleRequirementsForEcrfData = (e: any) => {
    dispatchApp(clearMessage());
    const val = e.target.value;
    const formattedVal = typeof val === 'string' ? formatInput(val) : val;
    const value = formattedVal;
    if (e.target.type === 'radio' && value === 'Y') {
      updateRequirementsforEcrfCompletion({
        ...requirementsforEcrfCompletionData,
        [e.target.name]: value
      });
      updateSIVReportMandatoryData('requirementsforEcrfcompletion', { ...mandatory, [e.target.name]: false });
    } else if (e.target.type === 'radio') {
      updateRequirementsforEcrfCompletion({
        ...requirementsforEcrfCompletionData,
        [e.target.name]: value
      });
      updateSIVReportMandatoryData('requirementsforEcrfcompletion', { ...mandatory, [e.target.name]: false });
    }
    //dispatch(setIsSaveButtonDisable(false))
    if (saveButtonDisable && e.target.type === 'radio') {
      dispatch(setIsSaveButtonDisable({ ...saveButtonDisable, requirementsforECrfcompletion: false }));
    }
    setConfirmExitValue(dispatch, true);
  };

  const handleChange = (e: any) => {
    if (e.target.type !== 'radio') {
      const val = e.target.value;
      const formattedVal = typeof val === 'string' ? formatInput(val) : val;
      const value = formattedVal;
      setRecentData({
        data: {
          ...recentData.data,
          [e.target.name]: value
        },
        mandatoryValidation: { ...recentData.mandatoryValidation, [e.target.name]: false }
      });
    }
    if (saveButtonDisable) {
      dispatch(setIsSaveButtonDisable(false));
    }
  };

  const setValidationData = () => {
    const copyValidation = { ...mandatory };
    for (const key of Object.keys(copyValidation)) {
      if (
        requirementsforEcrfCompletionData[key as keyof ISIVReportRequirementsforEcrfcompletion] === 'N' &&
        !(
          requirementsforEcrfCompletionData[`${key}_comm` as keyof ISIVReportRequirementsforEcrfcompletion] &&
          requirementsforEcrfCompletionData[`${key}_comm` as keyof ISIVReportRequirementsforEcrfcompletion] !== null &&
          requirementsforEcrfCompletionData[`${key}_comm` as keyof ISIVReportRequirementsforEcrfcompletion] !== ''
        )
      ) {
        copyValidation[key as keyof IRequirementsforEcrfcompletionMandatory] = true;
      } else {
        copyValidation[key as keyof IRequirementsforEcrfcompletionMandatory] = false;
      }
    }
    updateSIVReportMandatoryData('requirementsforEcrfcompletion', copyValidation);
    return copyValidation;
  };
  useEffect(() => {
    if (Object.keys(recentData.data).length) {
      updateRequirementsforEcrfCompletion({
        ...requirementsforEcrfCompletionData,
        ...recentData.data
      });
      updateSIVReportMandatoryData('requirementsforEcrfcompletion', {
        ...mandatory,
        ...recentData.mandatoryValidation
      });
    }
  }, [recentData.data]);
  const updateRequirementsForEcrfData = async () => {
    const validate = setValidationData();
    if (Object.values(validate).indexOf(true) !== -1) {
      return dispatchApp(setMessage({ msgDetails: sivcMendatoryInfoErrorMsg, severity: 'error' }));
    }
    const requirementsforEcrfCompletionDataTemp = { ...requirementsforEcrfCompletionData, ...recentData.data };
    const options = {
      site_id: selectedSite,
      study_id: studyId,
      data: {
        updated_by: user.user,
        monitoring_visit_id: selectedRowData?.id,
        siv_report: { step_two: { requirements_for_ecrf_completion: requirementsforEcrfCompletionDataTemp } }
      },
      pathVariables: {
        country: selectedCountry,
        appName: process.env.REACT_APP_NAME
      }
    };
    try {
      if (isChange) {
        if (isUpdate) {
          if (
            requirementsforEcrfCompletionDataTemp.siv_report_ecrf_guidelines !== null &&
            requirementsforEcrfCompletionDataTemp.siv_report_ecrf_guidelines_comm !== null
          ) {
            await sendRequest('update_siv_report', options);
            if (isPublished) {
              SignatureBreaking();
            }
            getSivReportData('requirementsforEcrfcompletion', false);
            setConfirmExitValue(dispatch, false);
            setIsChange('Step2', 'requirementsforEcrfcompletion', false);
            dispatchApp(setMessage({ msgDetails: sivcDataUpdateSuccessMsg, severity: 'success' }));
          } else {
            dispatchApp(setMessage({ msgDetails: sivcMendatoryInfoErrorMsg, severity: 'error' }));
          }
        }
        if (!isUpdate) {
          if (
            requirementsforEcrfCompletionDataTemp.siv_report_ecrf_guidelines !== null &&
            requirementsforEcrfCompletionDataTemp.siv_report_ecrf_guidelines_comm !== null
          ) {
            await sendRequest('create_siv_report', options);
            getSivReportData('requirementsforEcrfcompletion', true);
            setConfirmExitValue(dispatch, false);

            setIsChange('Step2', 'requirementsforEcrfcompletion', false);
            dispatchApp(setMessage({ msgDetails: sivcDataUpdateSuccessMsg, severity: 'success' }));
          } else {
            dispatchApp(setMessage({ msgDetails: sivcMendatoryInfoErrorMsg, severity: 'error' }));
          }
        }
      } else if (!isChange && requirementsforEcrfCompletionDataTemp.siv_report_ecrf_guidelines === null) {
        dispatchApp(setMessage({ msgDetails: sivcMendatoryInfoErrorMsg, severity: 'error' }));
      } else {
        dispatchApp(setMessage({ msgDetails: 'No data modified', severity: 'info' }));
      }
      dispatch(setIsSaveButtonDisable({ ...saveButtonDisable, requirementsforECrfcompletion: true }));
    } catch (e) {
      dispatchApp(setMessage({ msgDetails: sivcMendatoryInfoErrorMsg, severity: 'error' }));
    }
  };

  /**
   * Query menus code start
   */

  const {
    contextMenu,
    setContextMenu,
    queryKeys,
    setQueryKeys,
    checkListQueries,
    raisedQueries,
    totalFieldQueries,
    totalSectionQueries,
    fieldQueries,
    getSivReportQueries,
    raisedSectionQueries,
    report_id: reportId,
    setReport_id: setReportId,
    queryType,
    setQueryType,
    latestSecQueryRaisedBy
  } = useQueryMenus('SIV REPORT');

  useEffect(() => {
    setReportId(sivReportSavedId);
  }, [sivReportSavedId]);

  const handleContextMenu = (event: React.MouseEvent, checklistItem: keyof IRequirementsforEcrfcompletionMandatory) => {
    event.preventDefault();
    setContextMenu(
      contextMenu === null &&
        (checkPermission('view_queries_siv_report') ||
          checkPermission('view_audit_siv_report') ||
          checkPermission('raise_query_siv_report'))
        ? {
            mouseX: event.clientX - 2,
            mouseY: event.clientY - 4
          }
        : null
    );
    const sectionFieldNames: string[] = [];
    Object.keys(checkListQueries.requirements_for_ecrf_completion).forEach((obj: any) => {
      sectionFieldNames.push(checkListQueries.requirements_for_ecrf_completion[obj].report_field_name);
    });
    const newObj = {
      ...checkListQueries.requirements_for_ecrf_completion[checklistItem],
      id: sivReportSavedId,
      section_key: 'requirements_for_ecrf_completion',
      report_field_value: requirementsforEcrfCompletionData[checklistItem],
      section_field_names: sectionFieldNames,
      is_all_field_queries: true
    };
    setQueryKeys(newObj);
  };

  const [openViewQuery, setOpenViewQuery] = useState(false);
  const viewNotes = (checklistItem: keyof IRequirementsforEcrfcompletionMandatory, isAllFieldQueries = false) => {
    let newObj: any = {};
    if (isAllFieldQueries) {
      const sectionFieldNames: string[] = [];
      Object.keys(checkListQueries.requirements_for_ecrf_completion).forEach((obj: any) => {
        sectionFieldNames.push(checkListQueries.requirements_for_ecrf_completion[obj].report_field_name);
      });
      newObj = {
        ...checkListQueries.requirements_for_ecrf_completion[checklistItem],
        id: sivReportSavedId,
        section_key: 'requirements_for_ecrf_completion',
        section_field_names: sectionFieldNames,
        is_all_field_queries: isAllFieldQueries
      };
    } else {
      newObj = {
        ...checkListQueries.requirements_for_ecrf_completion[checklistItem],
        id: sivReportSavedId,
        section_key: 'requirements_for_ecrf_completion',
        report_field_value: requirementsforEcrfCompletionData[checklistItem],
        is_all_field_queries: isAllFieldQueries
      };
    }

    setQueryKeys(newObj);
    setOpenViewQuery(true);
    setQueryType('ALL');
  };
  /**
   * Query menus code end
   */
  return (
    <>
      <AccordionDetails className="sq-checklist-tab">
        <Grid container className="checklist-radio-actions">
          {raisedSectionQueries.includes(sectionNames.requirements_for_ecrf_completion) &&
            sectionNames.requirements_for_ecrf_completion in latestSecQueryRaisedBy &&
            SectionQueryIndication(
              latestSecQueryRaisedBy,
              sectionNames.requirements_for_ecrf_completion,
              viewNotes,
              'siv_report_ecrf_guidelines'
            )}
          <Grid md={12}>
            <Grid
              container
              onContextMenu={e => {
                handleContextMenu(e, 'siv_report_ecrf_guidelines');
              }}
              style={{ cursor: 'context-menu' }}
            >
              <Grid md={9}>
                {reportReqForECRFCompletion.label1}? <span style={{ color: 'red' }}>*</span>
              </Grid>
              <Grid md={3}>
                <Stack direction="row" spacing={1} justifyContent="space-between">
                  <FormControl>
                    <RadioGroup
                      value={requirementsforEcrfCompletionData.siv_report_ecrf_guidelines}
                      row
                      aria-labelledby="demo-row-radio-buttons-group-label"
                      name="siv_report_ecrf_guidelines"
                      onChange={handleRequirementsForEcrfData}
                    >
                      <FormControlLabel
                        disabled={!isDisable || saveDisable || !checkedInStartDate}
                        value="Y"
                        control={<Radio />}
                        label="Yes"
                      />
                      <FormControlLabel
                        disabled={!isDisable || saveDisable || !checkedInStartDate}
                        value="N"
                        control={<Radio />}
                        label="No"
                      />
                    </RadioGroup>
                  </FormControl>
                  <Button
                    onClick={() => viewNotes('siv_report_ecrf_guidelines')}
                    disabled={!perDisableQuery}
                    title="Query"
                    className={`grey-btn${
                      raisedQueries.includes('siv_report_ecrf_guidelines') ||
                      raisedSectionQueries.includes(sectionNames.requirements_for_ecrf_completion)
                        ? ' danger-link'
                        : ''
                    }`}
                  >
                    <LiveHelpOutlinedIcon />
                  </Button>
                </Stack>
              </Grid>
              <Grid md={12} className="comment-section">
                <FormControl fullWidth margin="normal" className="siv-comment-input">
                  <TextField
                    name="siv_report_ecrf_guidelines_comm"
                    key={`siv_report_ecrf_guidelines_comm-${refreshKey}`}
                    defaultValue={requirementsforEcrfCompletionData.siv_report_ecrf_guidelines_comm || ''}
                    onBlur={handleRequirementsForEcrfData}
                    error={mandatory['siv_report_ecrf_guidelines']}
                    helperText={mandatory['siv_report_ecrf_guidelines'] ? errorText : ''}
                    label="Notes"
                    variant="outlined"
                    inputProps={{ maxLength: NOTES_MAXLENGTH }}
                    disabled={!isDisable || saveDisable || !checkedInStartDate}
                    onChange={handleChange}
                    multiline
                    minRows={1}
                    maxRows={10}
                  />
                </FormControl>
              </Grid>
            </Grid>

            <Grid
              container
              onContextMenu={e => {
                handleContextMenu(e, 'siv_report_data_changes');
              }}
              style={{ cursor: 'context-menu' }}
            >
              <Grid md={9}>
                {reportReqForECRFCompletion.label2} <span style={{ color: 'red' }}>*</span>
              </Grid>
              <Grid md={3}>
                <Stack direction="row" spacing={1} justifyContent="space-between">
                  <FormControl>
                    <RadioGroup
                      value={requirementsforEcrfCompletionData.siv_report_data_changes}
                      row
                      aria-labelledby="demo-row-radio-buttons-group-label"
                      name="siv_report_data_changes"
                      onChange={handleRequirementsForEcrfData}
                    >
                      <FormControlLabel
                        disabled={!isDisable || saveDisable || !checkedInStartDate}
                        value="Y"
                        control={<Radio />}
                        label="Yes"
                      />
                      <FormControlLabel
                        disabled={!isDisable || saveDisable || !checkedInStartDate}
                        value="N"
                        control={<Radio />}
                        label="No"
                      />
                    </RadioGroup>
                  </FormControl>
                  <Button
                    onClick={() => viewNotes('siv_report_data_changes')}
                    disabled={!perDisableQuery}
                    title="Query"
                    className={`grey-btn${raisedQueries.includes('siv_report_data_changes') ? ' danger-link' : ''}`}
                  >
                    <LiveHelpOutlinedIcon />
                  </Button>
                </Stack>
              </Grid>
              <Grid md={12} className="comment-section">
                <FormControl fullWidth margin="normal" className="siv-comment-input">
                  <TextField
                    name="siv_report_data_changes_comm"
                    key={`siv_report_data_changes_comm-${refreshKey}`}
                    defaultValue={requirementsforEcrfCompletionData.siv_report_data_changes_comm || ''}
                    onBlur={handleRequirementsForEcrfData}
                    error={mandatory['siv_report_data_changes']}
                    helperText={mandatory['siv_report_data_changes'] ? errorText : ''}
                    label="Notes"
                    variant="outlined"
                    inputProps={{ maxLength: NOTES_MAXLENGTH }}
                    disabled={!isDisable || saveDisable || !checkedInStartDate}
                    onChange={handleChange}
                    multiline
                    minRows={1}
                    maxRows={10}
                  />
                </FormControl>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </AccordionDetails>
      <Grid container className="fixed-buttons-block">
        {checkPermission('update_siv_report') ? (
          <Grid md={12} display="flex" justifyContent="flex-end">
            <Stack spacing={2} direction="row">
              {isDisable ? (
                <Button
                  onClick={updateRequirementsForEcrfData}
                  disabled={saveButtonDisable?.requirementsforECrfcompletion || !checkedInStartDate}
                  variant="text"
                >
                  SAVE
                </Button>
              ) : (
                ''
              )}
            </Stack>
          </Grid>
        ) : (
          ''
        )}
        <QueryMenus
          totalFieldQueries={totalFieldQueries}
          totalSectionQueries={totalSectionQueries}
          contextMenu={contextMenu}
          setContextMenu={setContextMenu}
          queryKeys={queryKeys}
          fieldQueries={fieldQueries}
          getSivReportQueries={getSivReportQueries}
          report_id={reportId}
          checkListQueries={checkListQueries}
          queryType={queryType}
          setQueryType={setQueryType}
          isSQSivQueries
        />
        <ViewQuery
          totalFieldQueries={totalFieldQueries}
          totalSectionQueries={totalSectionQueries}
          open={openViewQuery}
          setOpen={setOpenViewQuery}
          queryKeys={queryKeys}
          queryType={queryType}
          fieldQueries={fieldQueries}
          getSivReportQueries={getSivReportQueries}
          setQueryType={setQueryType}
          report_id={reportId}
          isSQSivQueries
        />
      </Grid>
    </>
  );
};

export default RequirementsforEcrfcompletion;
